import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
const defaultCloseIconSize = {
    height: '16',
    width: '16',
};
export const CloseIcon = ({ height, width, ...rest }) => {
    return (_jsx(BaseIcon, { height: height || defaultCloseIconSize.height, width: width || defaultCloseIconSize.width, viewBox: '0 0 16 16', ...rest, children: _jsxs("g", { fillRule: 'evenodd', children: [_jsx("path", { fillRule: 'nonzero', d: 'M14 .586L.586 14 2 15.414 15.414 2z' }), _jsx("path", { fillRule: 'nonzero', d: 'M2 .586L15.414 14 14 15.414.586 2z' })] }) }));
};
//# sourceMappingURL=CloseIcon.js.map